define([
    "jquery",
    "underscore",
    "marionette",
    "forms/deposit/deposit_switch_payment_form",
    "behaviors/form_errors_behavior",
    "backbone.syphon",
    "holdon"
], function($, _, Marionette, SwitchPaymentForm, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            'deposit':'#deposit_btn',
            'depositButtonWrapper' : '#deposit-button-wrapper',
            'amount' : '#amount',
            'mt4AccountNo' : '#mt4_account_no',
            'currency' : '#currency_abbr',
        },

        events:{
            'click @ui.deposit': 'deposit',
            // 'change @ui.mt4AccountNo' : 'sendData',
            // 'change @ui.currency' : 'sendData',
        },

        initialize: function(){
            this.bindUIElements();
            // this.addEventListeners();
        },

        addEventListeners: function(){
            let that = this;

        },

        deposit: function(e) {
            e.preventDefault();
            let that = this;
            this.triggerMethod('hide:errors');

            // this.ui.depositButtonWrapper.hide();
            let data = {
                'mt4_account_no' : this.ui.mt4AccountNo.val(),
                'currency' : this.ui.currency.val(),
                'amount' : this.ui.amount.val()
            }
            HoldOn.open({
                theme:"sk-fading-circle"
            });

            $.ajax('/rest_deposit/switch_payment/deposit_temp', {
                method: 'POST',
                data: data,
                success: function(data){
                    that.ui.amount.attr('disabled','disabled');
                    that.ui.mt4AccountNo.attr('disabled', 'disabled');
                    that.ui.depositButtonWrapper.hide();
                    window.initSwitchPayment(data.transaction_id);
                    HoldOn.close();
                },
                error: function(xhr, textStatus, errorThrown){
                    var error = xhr.responseJSON;
                    that.triggerMethod('show:errors', error);
                    HoldOn.close();
                }
            })

            return false;
        },
    });
});